import { PsychologicalDocumentsUseCase } from '../../../../data/usecases'
import { makeAxiosHttpClient } from '../../../factories'

type ValidateReportModel = {
  id: string | number
}

export const fetchValidateReport = ({ id }: ValidateReportModel) => {
  return new PsychologicalDocumentsUseCase(
    `/laudo/modal/load/${id}`,
    makeAxiosHttpClient()
  )
}

export const saveValidateReport = ({ id }: ValidateReportModel) => {
  return new PsychologicalDocumentsUseCase(
    `/laudo/modal/save/${id}`,
    makeAxiosHttpClient()
  )
}
